import { getDeviceType } from 'js/utils/deviceDetection';
import { WEBPSUPPORT } from 'js/constants/App';

export const setBodyBackgroudColor = (color) => {
  getDeviceType() !== 'desktop' && (document.body.style.backgroundColor = color);
};

//stackoverflow.com/questions/5573096/detecting-webp-support
export const canUseWebP = () => {
  const elem = document.createElement('canvas');
  // eslint-disable-next-line no-extra-boolean-cast
  if (!!(elem.getContext && elem.getContext('2d'))) {
    const testString = !(window.mozInnerScreenX == null) ? 'png' : 'webp';
    // was able or not to get WebP representation

    if (elem.toDataURL('image/webp').indexOf('data:image/' + testString) == 0) {
      document.documentElement.classList.add('webp');
      return true;
    }
  }
  // very old browser like IE 8, canvas not supported
  return false;
};

export const convertFileExtensionToWebp = (url) => {
  if (!url) {
    return '';
  }
  return WEBPSUPPORT
    ? url.replace(new RegExp('.(' + ['jpg', 'jpeg', 'png', 'JPG', 'PNG', 'JPEG'].join('|') + ')$', 'i'), '.webp')
    : url;
};
